<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalDisplayWindowAndShowcase",
	components: { CaseForm },
	computed: {
		schema() {
			return [
				{
					label:
						"12. (a) Give full details of the type of glass in all your display windows and/or outside showcase.",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0GlassDetailsId",
					props: {
						suggest: {
							typeIncludes: "displayWindowsGlassDetails"
						},
						createOptions: {
							type: "displayWindowsGlassDetails",
							dataType: "string"
						}
					}
				},
				{
					label:
						"(b). (i) Are all sections of the windows containing jewellery, gold, silver, platinum, pearls and precious stones and watches substantially partitioned off from the remainder of the display?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0DisplayWindowsPartitionedOffId",
					props: {
						suggest: {
							typeIncludes: "displayWindowsPartitionedOff"
						},
						createOptions: {
							type: "displayWindowsPartitionedOff",
							dataType: "string"
						}
					}
				},
				{
					label:
						"(b). (ii) What precautions do you take to protect the rear of your display windows?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0DisplayWindowsPrecautionsId",
					props: {
						suggest: {
							typeIncludes: "displayWindowsPrecautions"
						},
						createOptions: {
							type: "displayWindowsPrecautions",
							dataType: "string"
						}
					}
				},
				{
					label:
						"(b). (iii) Are they kept permanently locked and keys removed?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0DisplayWindowsLockedAndKeysRemovedId",
					props: {
						suggest: {
							typeIncludes: "displayWindowsLockedAndKeysRemoved"
						},
						createOptions: {
							type: "displayWindowsLockedAndKeysRemoved",
							dataType: "string"
						}
					}
				},
				{
					label:
						"(b). (iv) Are interior showcases similarly locked and keys removed?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0InteriorShowcaseLockedAndKeysRemovedId",
					props: {
						suggest: {
							typeIncludes: "showcaseLockedAndKeysRemoved"
						},
						createOptions: {
							type: "showcaseLockedAndKeysRemoved",
							dataType: "string"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>(c) AT NIGHT and at all other times when premises are not open for business.</div>"
					},
					bindTo: ""
				},
				{
					label:
						"(i) Are all display windows and/or outside showcases protected externally by either shutters or by grille?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0DisplayWindowsExternallyProtectedId",
					props: {
						suggest: {
							typeIncludes: "displayWindowsExternallyProtected"
						},
						createOptions: {
							type: "displayWindowsExternallyProtected",
							dataType: "string"
						}
					}
				},
				{
					label:
						"(ii) Give full particulars of such protections and state how they are secured.",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo:
						"case.facts.insured0DisplayWindowsExternalProtectionDetailsId",
					props: {
						suggest: {
							typeIncludes: "displayWindowsExternalProtectionDetails"
						},
						createOptions: {
							type: "displayWindowsExternalProtectionDetails",
							dataType: "string"
						}
					}
				},
				{
					label:
						"(iii) Does this protection cover the entire front of your premises?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0ProtectionCoverPremisesFrontId",
					props: {
						suggest: {
							typeIncludes: "protectionCoverPremisesFront"
						},
						createOptions: {
							type: "protectionCoverPremisesFront",
							dataType: "string"
						}
					}
				},
				{
					label: "(iv) If not, give details.",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0ProtectionCoverPremisesFrontDetailsId",
					props: {
						suggest: {
							typeIncludes: "protectionCoverPremisesFrontDetails"
						},
						createOptions: {
							type: "protectionCoverPremisesFrontDetails",
							dataType: "string"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>(d) DURING BUSINESS HOURS</div>"
					},
					bindTo: ""
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 lh125'>Are all your display windows and/or outside showcases containing jewellery, gold, silver, platinum, pearls and precious stones and watches protected internally either by</div>"
					},
					bindTo: ""
				},
				{
					label:
						"(i) Fixed grilles covering the whole of the display? Give specification of these grilles.",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0GrillesSpecificationId",
					props: {
						suggest: {
							typeIncludes: "grillesSpecification"
						},
						createOptions: {
							type: "grillesSpecification",
							dataType: "string"
						}
					}
				},
				{
					label:
						"(ii) Hanging glass suspended between the window glass and the display? Give details and type of glass.",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SuspendedGlassDetailsId",
					props: {
						suggest: {
							typeIncludes: "suspendedGlassDetails"
						},
						createOptions: {
							type: "suspendedGlassDetails",
							dataType: "string"
						}
					}
				},
				{
					label:
						"(iii) Can the internal grilles or the suspended glass be reached under or over or around?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0InternalGrillesAccessibilityId",
					props: {
						suggest: {
							typeIncludes: "grillesAccessibility"
						},
						createOptions: {
							type: "grillesAccessibility",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
